import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, createSelector } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { TarifaPPDescuentosList } from "../descuentos";
import { ImportesPP } from "./importes";
export { ImportesPP } from "./importes";
import { ServiciosAdicionales } from "./servadic";

type Entity = models.TarifaPP;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un ChoferRuta
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        IdTarifa: validation.required,
        IdSucursalOrigen: validation.required,
        IdSucursalDestino: validation.required,
        IdContenidoPaquete: validation.required,
        IdDescripcionPaquete: validation.required,
        Peso: validation.required,
        Alto: validation.required,
        Ancho: validation.required,
        Largo: validation.required,
        
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class TarifaPPFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    datosRef = createSelector(this.value, x => ({
        IdSucursalOrigen: x.IdSucursalOrigen,
        IdSucursalDestino: x.IdSucursalDestino,
        ServiciosAdicionales: x.ServiciosAdicionales,
        IdContenidoPaquete: x.IdContenidoPaquete,
        IdDescripcionPaquete: x.IdDescripcionPaquete,
        Alto: x.Alto,
        Ancho: x.Ancho,
        Largo: x.Largo,
        Peso: x.Peso
    }as models.DatosReferenciaTarifaPP) )

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const ServAdic = getField(ServiciosAdicionales);
        const Number = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);
        const Tarifa = getField(selectores.Tarifa);
        const Checkbox = getField(kea.Checkbox);
        const Descuentos = getField(TarifaPPDescuentosList);
        const ContenidoPaq = getField(selectores.ContenidoPaquete);
        const DescripcionPaq = getField(selectores.DescripcionPaquete);

        return (
            <div>
                <kea.Title titulo="Tarifa de guía prepagada" onRegresar={() => history.go("../")} />
                {kea.autogrid(3, [
                    <Text field="Nombre" />,
                    <Checkbox field="Paquete" label="Aplica para paquetes" />,
                    <Checkbox field="Sobre" label="Aplica para sobres" />,
                ])}

                <kea.Panel title="Tarifa">
                    <div className="alert alert-info">
                        La tarifa determinará junto con los valores de referencia el precio de una guía de prepago, además,
                        el costo extra (si es que hay) estará basado en esta tarifa, el cual será el excedente entre el servicio documentado
                        y el precio base en función de los valores de referencia
                    </div>
                    <Tarifa field="IdTarifa" label="Tarifa de referencia" />
                </kea.Panel>

                <kea.Panel title="Valores de referencia">
                    <div className="alert alert-info">
                        Los valores de referencia determinarán el precio de una guía de prepago con esta tarifa, el costo extra será en
                        caso de que el precio calculado según la documentación y la tarifa de referencia supere al precio de referencia, la diferencia
                        entre estos valores
                    </div>

                    {kea.autogrid(3, [
                        <Sucursal field="IdSucursalOrigen" label="Suc. origen" />,
                        <Sucursal field="IdSucursalDestino" label="Suc. destino" />,
                        <Number field="Peso" label="Peso (kg)" />,
                        <Number field="Largo" label="Largo (cm)" />,
                        <Number field="Alto" label="Alto (cm)" />,
                        <Number field="Ancho" label="Ancho (cm)" />,
                        <ContenidoPaq field="IdContenidoPaquete" label="Contenido paquete" />,
                        <DescripcionPaq field="IdDescripcionPaquete" label="Descripción paquete" />
                    ])}

                    <ServAdic field="ServiciosAdicionales" />
                </kea.Panel>

                <Descuentos field="Descuentos" />

                <h4>Precios</h4>
                
                {kea.autogrid(6, [
                    <div>
                        <h5>Paquete</h5>
                        <ImportesPP idTarifa={value.IdTarifa} tipoServicio={models.TipoServicio.Paquete} datosRef={this.datosRef(this.props)} />
                    </div>,
                    <div>
                        <h5>Sobre</h5>
                        <ImportesPP idTarifa={value.IdTarifa} tipoServicio={models.TipoServicio.Sobre} datosRef={this.datosRef(this.props)} />
                    </div>
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const TarifaPPForm = componentToRx(TarifaPPFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/edit/form.tsx